import {Component, OnDestroy, OnInit} from '@angular/core';
import {concat, from, Observable, of, ReplaySubject} from 'rxjs';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {catchError, concatMap, filter, takeUntil, tap} from 'rxjs/operators';
import {FileResult} from '../../../shared/components/file-drag-and-drop/file-drag-and-drop.component';
import {HttpErrorResponse} from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import {IddTrainingCertificate} from "../../../shared/interface/idd-training-certificate";

@Component({
  selector: 'app-decode-idd-training-certificates',
  templateUrl: './decode-idd-training-certificates.component.html',
  styleUrls: ['./decode-idd-training-certificates.component.scss']
})
export class DecodeIddTrainingCertificatesComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  certificateFormValid = false;
  certificateForm: FormGroup;
  fileControl: FormControl;
  trainingASFControl: FormControl;
  processingRequest = false;
  formErrors = {};
  fileResults: FileResult[] = [];
  iddCertificateObject?: IddTrainingCertificate = null ;
  modify = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private iddTrainingService: IddTrainingService,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
  ) {
    this.trainingASFControl = fb.control(true);
    this.certificateForm = fb.group({
      file: this.fileControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.certificateForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.certificateFormValid = this.certificateForm.valid;
      });

    this.fileControl.valueChanges
      .pipe(
        takeUntil(this.destroyed$),
        filter((file?: File[]) => !!file)
      )
      .subscribe(() => {
        this.fileResults = [];
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  save(): void {
    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.certificateForm, this.formErrors);
    this.formErrors = {};
    this.fileResults = [];

    const forms: Observable<any>[] = [];
    this.fileControl.value?.forEach((file: File) => {
      const reader = new FileReader();
      const uuidV4 = uuidv4();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (this.trainingASFControl.value) {
          forms.push(this.iddTrainingService.decodeCertificates({
            fileContents: (/base64,(.+)/.exec(reader.result.toString())[1]),
            fileNames: file.name,
            uuid: uuidV4,
          }).pipe(
            tap(() => {
              this.fileResults.push({
                file,
                result: true,
                uuid: uuidV4,
              });
            }, (error: HttpErrorResponse) => {
              this.fileResults.push({
                file,
                result: false,
                uuid: uuidV4,
              });
              this.processingRequest = false;
            }),
          ));
        } else {
          forms.push(this.iddTrainingService.decodeCertificatesInsuranceCompany({
            fileContents: (/base64,(.+)/.exec(reader.result.toString())[1]),
            fileNames: file.name,
              uuid: uuidV4,
          }).pipe(
              tap(() => {
                this.fileResults.push({
                  file,
                  result: true,
                  uuid: uuidV4,
                });
              }),
              catchError((error: HttpErrorResponse) => {
                this.fileResults.push({
                  file,
                  result: false,
                  error: error.error.error.text,
                  uuid: uuidV4,
                });

                return of(null);
              })
            )
          );
        }

        if (forms.length === this.fileControl.value?.length) {
          from(forms)
            .pipe(concatMap(form => form))
            .subscribe({
              complete: () => {
                this.processingRequest = false;
              }
            });
        }
      };
    });
  }

  cancel(): void {
    this.router.navigate(['/szkolenia-idd']);
  }

  open(uuid): void {
    this.iddTrainingService.getCertificates(uuid).subscribe(
      (iddCertificateObject: IddTrainingCertificate) => {
        this.iddCertificateObject = iddCertificateObject;
      }
    );
  }

}
